"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTestId = generateTestId;
/**
 * Generate a stable `data-testid` string.
 *
 * Format:
 *   <base>[__<slot>][--<index>][--<modifierA>--<modifierB>...]
 *
 * Examples:
 *   generateTestId({ base: "profile__email", slot: "input" })
 *   // "profile__email__input"
 *
 *   generateTestId({ base: "users", slot: "item", index: "u-100" })
 *   // "users__item--u-100"
 *
 *   generateTestId({ base: "filters", slot: "chip", modifiers: ["selected", "lg"] })
 *   // "filters__chip--selected--lg"
 *
 * Guidance:
 * - Keep `base` stable and human-readable (don’t derive from user text or use UUIDs).
 * - For repeated items, prefer stable business keys for `index` (e.g., `user.id`).
 * - Use `modifiers` to encode state/variants cleanly in selectors.
 */

const SLOT_SEP = '__';
const MOD_SEP = '--';

/** Returns the composed id, or `undefined` if `base` is missing. */
function generateTestId(params) {
  const {
    base,
    slot,
    index,
    modifiers = []
  } = params;
  if (!base) {
    return undefined;
  }
  let id = slot ? `${base}${SLOT_SEP}${slot}` : base;
  if (typeof index !== 'undefined') {
    id += `${MOD_SEP}${String(index)}`;
  }
  const mods = modifiers.filter(m => Boolean(m)).map(String);
  if (mods.length > 0) {
    id += `${MOD_SEP}${mods.join(MOD_SEP)}`;
  }
  return id;
}